<ng-container *ngIf="!loading">

  <!-- Mobile top navbar -->
  <nav class="wefit-mobile-nav d-lg-none">
    <button class="wefit-hamburger" (click)="toggleSidebar()" type="button">
      <i class="fa-solid fa-bars"></i>
    </button>
    <span class="wefit-mobile-title">WEFIT</span>
    <div class="d-flex align-items-center" style="gap:8px;">
      <button class="wefit-dys-btn" [class.active]="isDys" (click)="openAccessibility()" type="button" [title]="'Accessibilité' | translate">
        <i class="fa-solid fa-universal-access"></i>
      </button>
      <ng-container *ngIf="providerId | providerLogo as logoUrl; else mobileDefaultLogo">
        <img [src]="logoUrl" width="36" alt="WeFit">
      </ng-container>
      <ng-template #mobileDefaultLogo>
        <img src="/assets/images/wefit-white.png" width="36" alt="WeFit">
      </ng-template>
      <img *ngIf="groupLogoUrl" [src]="groupLogoUrl" class="wefit-group-logo" width="36" alt="">
    </div>
  </nav>

  <!-- Overlay mobile -->
  <div class="wefit-overlay" [class.active]="sidebarOpen" (click)="closeSidebar()"></div>

  <!-- Sidebar -->
  <aside class="wefit-sidebar" [class.open]="sidebarOpen">

    <!-- Header rose -->
    <div class="wefit-sidebar-header">
      <img *ngIf="providerId | providerLogo as logoUrl; else defaultLogo"
           [src]="logoUrl" width="70" alt="WeFit">
      <ng-template #defaultLogo>
        <img src="/assets/images/wefit-white.png" width="70" alt="WeFit">
      </ng-template>
      <img *ngIf="groupLogoUrl" [src]="groupLogoUrl" class="wefit-group-logo" width="70" alt="">
      <button class="wefit-close-btn d-lg-none" (click)="closeSidebar()" type="button">
        <i class="fa-solid fa-xmark"></i>
      </button>
    </div>

    <!-- Nav scrollable -->
    <div class="wefit-sidebar-nav">

      <!-- J'APPRENDS -->
      <div class="wefit-nav-label" *ngIf="languages.length" translate>J'apprends</div>

      <!-- Dropdown langue cible -->
      <div class="wefit-lang-dropdown" *ngIf="languages.length" #langDropdown>
        <button type="button" class="wefit-lang-toggle" [class.open]="langDropdownOpen" (click)="toggleLangDropdown()">
          <img *ngIf="currentLang" src="assets/images/flags/{{currentLang.flag}}" [alt]="currentLang.name" width="26" height="26">
          <span class="wefit-lang-name">{{ (currentLang ? langLabel(currentLang) : 'Choisir une langue') | translate }}</span>
          <i class="fa-solid fa-chevron-down wefit-lang-chevron"></i>
        </button>

        <div class="wefit-lang-menu" *ngIf="langDropdownOpen">
          <a
            *ngFor="let lang of languages; trackBy: trackById"
            class="wefit-lang-option"
            [class.active]="langTgtSrv.current?.code === lang.code"
            (click)="selectLanguage(lang)">
            <img src="assets/images/flags/{{lang.flag}}" [alt]="lang.name" width="26" height="26">
            <span class="wefit-lang-name">{{ langLabel(lang) | translate }}</span>
            <span class="wefit-lang-level"
                  *ngIf="langTgtSrv.current?.code !== lang.code && langLevelMap[lang.code]">{{ langLevelMap[lang.code] }}</span>
            <i class="fa-solid fa-check" *ngIf="langTgtSrv.current?.code === lang.code"></i>
          </a>
        </div>
      </div>

      <!-- LIVE PRACTICE -->
      <div class="wefit-nav-label" translate>Live Practice</div>

      <!-- Mode LMS2 : Visio INDIV / INTRA / INTER -->
      <ng-container *ngIf="isLms2; else standardLivePractice">
        <div class="wefit-nav-item wefit-nav-muted" style="--nav-color:#06b6d4; --nav-color-light:#ECFEFF;"
             [class.wefit-nav-disabled]="!isFeatureAvailable('visio')">
          <a class="wefit-nav-link pointer" (click)="goToWefitPage(wefitPages.visioIndiv)">
            <i class="fa-solid fa-camera-web"></i> Visio&nbsp;<span class="wefit-nav-kw">INDIV</span>
          </a>
        </div>
        <div class="wefit-nav-sep"></div>


        <div class="wefit-nav-item wefit-nav-muted" style="--nav-color:#7C3AED; --nav-color-light:#F3EEFF;"
             [class.wefit-nav-disabled]="!isFeatureAvailable('vc')">
          <a class="wefit-nav-link pointer" (click)="goToWefitPage(wefitPages.visioInter)">
            <i class="fa-solid fa-people-group"></i> Virtual Class
          </a>
        </div>
      </ng-container>

      <!-- Mode standard : Visio + Virtual Class -->
      <ng-template #standardLivePractice>
        <div class="wefit-nav-item" style="--nav-color:#D9004C; --nav-color-light:#FFF0F5;"
             [class.wefit-nav-disabled]="!isFeatureAvailable('visio')">
          <a class="wefit-nav-link pointer" (click)="goToWefitPage(wefitPages.visio)">
            <i class="fa-solid fa-camera-web"></i> Visio
          </a>
        </div>
        <div class="wefit-nav-sep"></div>

        <div class="wefit-nav-item" style="--nav-color:#7C3AED; --nav-color-light:#F3EEFF;"
             [class.wefit-nav-disabled]="!isFeatureAvailable('vc')">
          <a class="wefit-nav-link pointer" (click)="goToWefitPage(wefitPages.virtualClass)">
            <i class="fa-solid fa-users-viewfinder"></i> Virtual Class
          </a>
        </div>
      </ng-template>

      <!-- SELF LEARNING -->
      <div class="wefit-nav-label mt-5 mb-3" translate>Self Learning</div>

      <!-- Serious GAME (actif) -->
      <div class="wefit-nav-item wefit-nav-active"
           [class.wefit-nav-disabled]="!isFeatureAvailable('game')"
           style="--nav-color:#3B82F6; --nav-color-light:#EFF6FF;">
        <a class="wefit-nav-link pointer"
           [routerLink]="['/', langSrcSrv.current?.shortCode, 'learning', 'dashboard']"
           (click)="closeSidebar()">
          <i class="fa-solid fa-gamepad"></i>
          Serious&nbsp;<span class="wefit-nav-kw">GAME</span>
        </a>
      </div>

      <div class="wefit-nav-sep"></div>

      <!-- We ADVANCE -->
      <div class="wefit-nav-item wefit-nav-muted" style="--nav-color:#10B981; --nav-color-light:#ECFDF5;"
           [class.wefit-nav-disabled]="!isFeatureAvailable('advance')">
        <a class="wefit-nav-link pointer" (click)="goToWefitPage(wefitPages.weAdvance)">
          <i class="fa-solid fa-comment-nodes"></i>
          We&nbsp;<span class="wefit-nav-kw">ADVANCE</span>
        </a>
      </div>

      <div class="wefit-nav-sep"></div>

      <!-- Exam PREP -->
      <div class="wefit-nav-item wefit-nav-muted" style="--nav-color:#F59E0B; --nav-color-light:#FFFBEB;"
           [class.wefit-nav-disabled]="!isFeatureAvailable('exam')">
        <a class="wefit-nav-link pointer" (click)="goToWefitPage(wefitPages.examPrep)">
          <i class="fa-solid fa-medal"></i>
          Exam&nbsp;<span class="wefit-nav-kw">PREP</span>
        </a>
      </div>

    </div>

    <!-- Footer rose -->
    <div class="wefit-sidebar-footer"></div>

  </aside>

</ng-container>
